module.exports = __webpack_public_path__ + "img/11825388_S.ae5aafae.png";